import { cn } from '@repo/videa-components/src/lib/utils';
import { useSelector } from 'react-redux';

interface PatientNamePrivacyProps {
  name: string;
  className?: string;
  showInitials?: boolean;
  noWrap?: boolean;
}

export const PatientNamePrivacy = ({
  name,
  className = '',
  showInitials = true,
  noWrap = false,
}: PatientNamePrivacyProps) => {
  const privacyOn = useSelector((state: any) => state.login?.user?.privacyOn);

  if (!name) {
    return null;
  }

  // If privacy is ON (displaying PHI), show the full name
  if (privacyOn) {
    return (
      <span
        className={cn(
          'vai-capitalize',
          noWrap && 'vai-whitespace-nowrap',
          className,
        )}
      >
        {name}
      </span>
    );
  }

  // If privacy is OFF (hiding PHI), show blurred name
  if (showInitials) {
    const nameParts = name.split(' ');

    return (
      <span
        className={cn(
          'vai-inline-flex vai-gap-1',
          noWrap ? 'vai-whitespace-nowrap' : 'vai-flex-wrap',
          className,
        )}
      >
        {nameParts.map((part, index) => (
          <div key={index} className="vai-inline-flex vai-items-center">
            <span className="vai-inline-block">{part[0]}</span>
            <span className="vai-text-gray-300 vai-blur-[2px] vai-select-none vai-text-sm vai-inline-block">
              &#x2588;&#x2588;&#x2588;
            </span>
          </div>
        ))}
      </span>
    );
  }

  // Fallback: just show blurred blocks
  return (
    <span
      className={cn(
        'vai-text-gray-300 vai-blur-[2px] vai-select-none vai-text-sm',
        noWrap && 'vai-whitespace-nowrap',
        className,
      )}
    >
      &#x2588;&#x2588;&#x2588;&#x2588;&#x2588;&#x2588;&#x2588;&#x2588;
    </span>
  );
};
